import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import {
  BaseDialog,
  BaseTextContent,
  BaseButton,
  XrkMessage
} from 'xrk-components';
import { makeOutAnInvoice } from '@V/invoice/src/data-source/apis';
import {
  MakeOutAnInvoiceParams,
  NotInvoicedListParams
} from '@V/invoice/src/data-source/types';
import InvoiceDetailIndividualDialogContent from './invoice-detail-individual-dialog-content.vue';
import InvoiceDetailIndividualDialogList from './invoice-detail-individual-dialog-list.vue';
import InvoiceDetailIndividualDialogForm from './invoice-detail-individual-dialog-form.vue';
import { translator } from '@/utils';

type FormData = MakeOutAnInvoiceParams & NotInvoicedListParams;


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-detail-individual-dialog',
  props: {
    remove: { type: Function, default() {
      return () => {
        console.log('remove');
      };
    } }
  },
  emits: ["success"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const contentRef = ref();
const formRef = ref();
// 提交数据与列表搜索数据放一起了
const formData = ref<FormData>({
  theSellerId: null,
  itemId: null,
  invoiceType: null,
  openOrderIds: [],
  addressId: null,
  userDefinedOrderType: null,
  imgList: [],
  fileList: [],
  taskAt: '',
  invoiceAmount: null, // 勾选的金额
  stateType: 7, // 写死
  isBaseAsp: 1, // 写死
  auditSign: 0 // 写死
});

const onCancel = () => {
  props.remove();
};
const onConfirm = async () => {
  await Promise.all([contentRef.value.validate(), formRef.value.validate()]);
  if (!formData.value.openOrderIds.length) {
    XrkMessage.error('请选择订单');
    return;
  }
  await makeOutAnInvoice({
    ...formData.value,
    imgList: formData.value.imgList.map(item => {
      return {
        ...item,
        ...(item.invoiceAmount && {
          invoiceAmount: translator.yuan2fen(item.invoiceAmount)
        })
      };
    })
  });
  emits('success');
  props.remove();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    width: "950px",
    title: "上传发票",
    "model-value": true,
    "close-on-press-escape": true,
    "close-on-click-modal": false
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(BaseButton), {
        type: "default",
        onClick: onCancel
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }),
      _createVNode(_unref(BaseButton), { onClick: onConfirm }, {
        default: _withCtx(() => [
          _createTextVNode("确认")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(BaseTextContent), null, {
        default: _withCtx(() => [
          _createVNode(InvoiceDetailIndividualDialogContent, {
            ref_key: "contentRef",
            ref: contentRef,
            modelValue: formData.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData).value = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(InvoiceDetailIndividualDialogList, {
            contentRef: contentRef.value,
            modelValue: formData.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData).value = $event))
          }, null, 8, ["contentRef", "modelValue"]),
          _createVNode(InvoiceDetailIndividualDialogForm, {
            ref_key: "formRef",
            ref: formRef,
            modelValue: formData.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData).value = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})